<template>
  <div class="profil-container" v-if="bank.length > 0">
    <h3 class="profil-title" v-if="formIsActive(bank[0])">{{ bank[0].text }}</h3>
    <p class="profil-subtitle" v-if="formIsActive(bank[1])">{{ bank[1].text }}</p>

    <div class="vendor-form-wrapper">
      <div class="vendor-form" v-for="(list, index) in bank.slice(2)" :key="index" v-if="formIsActive(list)">
        <p class="vendor-form-label">
          {{ list.text }}<span v-if="list.is_mandatory" class="text-ast">*</span>
        </p>

        <input v-if="list.name == 'Bank-3'" type="text" class="vendor-input" placeholder="NAMA VENDOR"
          v-model="pemilikBank"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />

        <input v-if="list.name == 'Bank-4'" type="text" class="vendor-input" v-model="selectedBankInter"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />

        <input v-if="list.name == 'Bank-5'" type="text" class="vendor-input" v-model="bankBranchOffice"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />

        <input v-if="list.name == 'Bank-6'" type="number" class="vendor-input" v-model="accountNumber" />

        <div class="vendor-input" v-if="list.name == 'Bank-7'">
          <v-select class="style-chooser" placeholder="Pilih Mata Uang" label="kode_mata_uang" :options="countryList"
            v-model="mataUang" autocomplete="negara" />
        </div>

        <the-mask v-if="list.name == 'Bank-8'" class="vendor-input" :mask="['##.###.###.#-###.###']"
          placeholder="XX.XXX.XXX.X-XXX.XXX" v-model="npwpBank" />

        <master-data-input-list :list="list" :step="'md_step_4'" :i="index" v-if="list.question_type !== 'default'" />
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goAfiliasi()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'bank',
  data() {
    return {
      bankList: [],
      countryList: [],
    }
  },
  created() {
    // this.getBank()
    this.getCountry()
  },
  computed: {
    bank() {
      return this.$store.state.landingpage.md_step_4
    },
    pemilikBank: {
      get: function () {
        return this.$store.state.landingpage.pemilikBank
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pemilikBank',
          value: newValue,
        })
      },
    },
    selectedBankCountry: {
      get: function () {
        return this.$store.state.landingpage.selectedBankCountry
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'selectedBankCountry',
          value: newValue,
        })
      },
    },
    selectedBank: {
      get: function () {
        return this.$store.state.landingpage.selectedBank
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'selectedBank',
          value: newValue.desc,
        })
      },
    },
    selectedBankInter: {
      get: function () {
        return this.$store.state.landingpage.selectedBank
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'selectedBank',
          value: newValue,
        })
      },
    },
    bankBranchOffice: {
      get: function () {
        return this.$store.state.landingpage.bankBranchOffice
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'bankBranchOffice',
          value: newValue,
        })
      },
    },
    accountNumber: {
      get: function () {
        return this.$store.state.landingpage.accountNumber
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'accountNumber',
          value: newValue,
        })
      },
    },
    mataUang: {
      get: function () {
        return this.$store.state.landingpage.mataUang
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'mataUang',
          value: newValue && newValue.kode_mata_uang,
        })
      },
    },
    npwpBank: {
      get: function () {
        return this.$store.state.landingpage.npwpBank
      },
      set: function (newValue) {
        // XX.XXX.XXX.X-XXX.XXX
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'npwpBank',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {

      let arr = []

      let bank = this.bank.slice(2)
      for (let i in bank) {
        if (bank[i].name == 'Bank-3' && bank[i].is_mandatory && bank[i].is_active) { arr.push([this.pemilikBank, bank[i].text]) }
        else if (bank[i].name == 'Bank-4' && bank[i].is_mandatory && bank[i].is_active) { arr.push([this.selectedBankInter, bank[i].text]) }
        else if (bank[i].name == 'Bank-5' && bank[i].is_mandatory && bank[i].is_active) { arr.push([this.bankBranchOffice, bank[i].text]) }
        else if (bank[i].name == 'Bank-6' && bank[i].is_mandatory && bank[i].is_active) { arr.push([this.accountNumber, bank[i].text]) }
        else if (bank[i].name == 'Bank-7' && bank[i].is_mandatory && bank[i].is_active) { arr.push([this.mataUang, bank[i].text]) }
        else if (bank[i].name == 'Bank-8' && bank[i].is_mandatory && bank[i].is_active) { arr.push([this.npwpBank, bank[i].text]) }
        else if (!bank[i].is_default && bank[i].is_active && bank[i].is_mandatory) {
          arr.push([bank[i].form_value, bank[i].text])
        }
      }

      return this.multiConditions(arr)
    },
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
    },
    goAfiliasi() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_step',
          value: true,
        })
      }
    },
    async getBank() {
      try {
        const url = `${api}/api/v1/bank?page=1&limit=100`
        const { data } = await axios({
          method: 'GET',
          url,
        })
        this.bankList = data.data
      } catch (error) { }
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countryList = data.data
      } catch (error) { }
    },
  },
}
</script>
